// src/Dashboard/pages/user/Galleries/components/AlbumHeader.jsx

import React from "react";
import {
  FaChevronLeft,
  FaImages,
  FaMinus,
  FaPlus,
  FaShareAlt,
  FaSyncAlt,
} from "react-icons/fa";

export default function AlbumHeader({
  gallery,
  loading,
  photosCount,
  isManager,
  onBack,
  onRefresh,
  onShare,
  onAdd,
  onRemove,
}) {
  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="bg-gradient-to-r from-[#013E8E] via-indigo-600 to-[#4CA82F] px-5 py-6 text-white sm:px-8">
        <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
          <div className="min-w-0">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-1 text-xs font-bold uppercase tracking-wide ring-1 ring-white/20">
              <FaImages />
              Album photos
            </div>

            <h1 className="mt-4 line-clamp-2 text-2xl font-bold sm:text-3xl">
              {gallery?.titre || "Album"}
            </h1>

            <p className="mt-2 text-sm leading-6 text-white/90">
              {photosCount} photo{photosCount > 1 ? "s" : ""} dans cet album.
            </p>
          </div>

          <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:justify-end">
            <button
              type="button"
              onClick={onBack}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white px-4 py-3 text-sm font-bold text-slate-900 shadow-sm transition hover:bg-white/90"
            >
              <FaChevronLeft />
              Retour
            </button>

            <button
              type="button"
              onClick={onRefresh}
              disabled={loading}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white/15 px-4 py-3 text-sm font-bold text-white ring-1 ring-white/20 transition hover:bg-white/20 disabled:opacity-70"
            >
              <FaSyncAlt className={loading ? "animate-spin" : ""} />
              Actualiser
            </button>

            <button
              type="button"
              onClick={onShare}
              className="inline-flex items-center justify-center gap-2 rounded-2xl bg-white/15 px-4 py-3 text-sm font-bold text-white ring-1 ring-white/20 transition hover:bg-white/20"
            >
              <FaShareAlt />
              Partager
            </button>

            {isManager && (
              <>
                <button
                  type="button"
                  onClick={onAdd}
                  className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-950 px-4 py-3 text-sm font-bold text-white shadow-sm transition hover:bg-slate-800"
                >
                  <FaPlus />
                  Ajouter
                </button>

                <button
                  type="button"
                  onClick={onRemove}
                  className="inline-flex items-center justify-center gap-2 rounded-2xl bg-red-600 px-4 py-3 text-sm font-bold text-white shadow-sm transition hover:bg-red-700"
                >
                  <FaMinus />
                  Retirer
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}